"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _nl = _interopRequireDefault(require("../../locals/nl.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Label = _interopRequireDefault(require("../Label"));
var _Option = _interopRequireDefault(require("../Option"));
var _SearchField = _interopRequireDefault(require("../SearchField"));
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _sortOptions = _interopRequireDefault(require("../../utils/sortOptions"));
var _Select = _interopRequireDefault(require("./Select.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Select = _ref => {
  let {
    accordionOpenOnDefault = false,
    accordionVisibleOptions = 6,
    identifier,
    label,
    lang,
    loading = false,
    maxVisibleOptions = 6,
    multiple = true,
    onChange,
    options = [],
    showAccordion = false,
    showAll = true,
    showAllOptions: _showAllOptions = false,
    showCount = true,
    showIfCountMoreThanZero = false,
    showSearch = true,
    showSelectedValues = false,
    sort = true,
    value,
    CheckboxProps,
    SearchFieldProps
  } = _ref;
  const [filteredOptions, setFilteredOptions] = (0, _react.useState)([]);
  const [keyword, setKeyword] = (0, _react.useState)("");
  const [accordionOpen, setAccordionOpen] = (0, _react.useState)(accordionOpenOnDefault);
  const [hasInvisibleOptions, setHasInvisibleOptions] = (0, _react.useState)(false);
  const [showAllOptions, setShowAllOptions] = (0, _react.useState)(_showAllOptions);
  const [hasActiveSelected, setHasActiveSelected] = (0, _react.useState)(false);
  const [hasChildItems, setHasChildItems] = (0, _react.useState)(false);
  const css = (0, _Select.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      nl: _nl.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (keyword) return;
    if (sort) {
      setFilteredOptions(cutVisibleEntries((0, _sortOptions.default)(options)));
      return;
    }
    setFilteredOptions(cutVisibleEntries(options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasChildItems, keyword, options, sort]);
  (0, _react.useEffect)(() => {
    const hasSelected = options?.findIndex(option => option.selected === true);
    if (hasSelected > -1) {
      setAccordionOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isChecked = (0, _react.useCallback)(id => {
    if (multiple) return value?.indexOf(id) > -1;
    return value === id;
  }, [multiple, value]);
  const handleSearch = (0, _debounce.default)(value => {
    let tmpOptions = JSON.parse(JSON.stringify(options));
    tmpOptions = tmpOptions?.filter(tmpOption => {
      const formattedTitle = tmpOption.title.toLowerCase();
      return formattedTitle.indexOf(value.toLowerCase()) > -1;
    });
    setFilteredOptions((0, _sortOptions.default)((0, _isEmpty.default)(tmpOptions) ? options : tmpOptions));
  }, 500);
  const handleAccordionChange = (event, isExpanded) => {
    setAccordionOpen(isExpanded);
  };
  const cutVisibleEntries = items => {
    if (showAllOptions) return items;
    const filtered = items?.filter((item, counter) => {
      const {
        selected
      } = item;
      if (selected || hasChildItems) return true;
      if (counter < accordionVisibleOptions) return true;
      return false;
    });
    if (items.length > filtered.length) {
      setHasInvisibleOptions(true);
    }
    return filtered;
  };
  (0, _react.useEffect)(() => {
    if (showAllOptions) {
      setHasInvisibleOptions(false);
      if (sort) {
        setFilteredOptions((0, _sortOptions.default)(options));
        return;
      }
      setFilteredOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAllOptions]);
  (0, _react.useEffect)(() => {
    let hasSelected = false;
    options?.forEach(option => {
      const {
        selected
      } = option;
      if (selected) {
        hasSelected = true;
      }
    });
    setHasActiveSelected(hasSelected);
  }, [options]);
  (0, _react.useEffect)(() => {
    const hasItems = options?.findIndex(option => {
      const {
        items = []
      } = option;
      return items.length > 0;
    });
    setHasChildItems(hasItems > -1);
  }, [options]);
  const handleShowAll = () => {
    onChange(identifier, null, true);
  };
  if (loading) return /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    isAccordion: showAccordion
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, "mco-filter-item", {
      [css.itemAccordion]: showAccordion,
      "mco-filter-item__accordion": showAccordion
    })
  }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: showAccordion,
    wrapper: children => /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      classes: {
        root: (0, _clsx.default)(css.accordion, "mco-filter-item__accordion")
      },
      expanded: accordionOpen,
      onChange: handleAccordionChange
    }, /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, {
      classes: {
        root: (0, _clsx.default)(css.accordionLabel, "mco-filter-item__accordion-label"),
        content: (0, _clsx.default)(css.accordionLabelContent, "mco-filter-item__accordion-label-content")
      },
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      label: label,
      showSelectedValues: showSelectedValues,
      values: filteredOptions
    })), /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, {
      classes: {
        root: (0, _clsx.default)(css.accordionContent, "mco-filter-item__accordion-content")
      }
    }, children))
  }, !showAccordion && label && /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    label: label
  })), showSearch && options?.length > maxVisibleOptions && accordionVisibleOptions > 0 && !hasChildItems && /*#__PURE__*/_react.default.createElement(_SearchField.default, _extends({
    keyword: keyword,
    lang: lang,
    onSearch: e => {
      const value = e.target.value;
      setKeyword(value);
      handleSearch(value);
    }
  }, SearchFieldProps)), showAll && /*#__PURE__*/_react.default.createElement(_Option.default, {
    checked: !hasActiveSelected,
    identifier: identifier,
    key: 0,
    onChange: handleShowAll,
    multiple: multiple,
    showCount: false,
    title: l("filterItem.labels.showAll"),
    CheckboxProps: CheckboxProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.optionsWrapper, "mco-filter-item__option-wrapper")
  }, filteredOptions?.map(option => {
    const {
      count,
      id,
      items,
      title
    } = option;
    console.log(showIfCountMoreThanZero, count, title);
    if (showIfCountMoreThanZero && count === 0) return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: id
    });
    if (hasChildItems) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: id
      }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
        classes: {
          root: (0, _clsx.default)(css.subAccordion, "mco-filter-item__sub-accordion")
        }
      }, /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, {
        classes: {
          root: (0, _clsx.default)(css.subAccordionLabel, "mco-filter-item__sub-accordion-label"),
          content: (0, _clsx.default)(css.subAccordionLabelContent, "mco-filter-item__sub-accordion-label-content")
        },
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
      }, /*#__PURE__*/_react.default.createElement(_Option.default, {
        checked: isChecked(id),
        count: count,
        id: id,
        identifier: identifier,
        key: id,
        onChange: onChange,
        multiple: multiple,
        showCount: false,
        title: title,
        CheckboxProps: CheckboxProps
      })), /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, {
        classes: {
          root: (0, _clsx.default)(css.subAccordionContent, "mco-filter-item__sub-accordion-content")
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx.default)(css.optionsWrapper, "mco-filter-item__option-wrapper")
      }, items?.map(subItem => {
        const {
          count: subCount,
          id: subId,
          title: subTitle
        } = subItem;
        if (showIfCountMoreThanZero && subCount === 0) return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: id
        });
        return /*#__PURE__*/_react.default.createElement(_Option.default, {
          checked: isChecked(subId),
          count: subCount,
          id: subId,
          identifier: identifier,
          key: subId,
          onChange: onChange,
          multiple: multiple,
          showCount: showCount,
          title: subTitle,
          CheckboxProps: CheckboxProps
        });
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(_Option.default, {
      checked: isChecked(id),
      count: count,
      id: id,
      identifier: identifier,
      key: id,
      onChange: onChange,
      multiple: multiple,
      showCount: showCount,
      title: title,
      CheckboxProps: CheckboxProps
    });
  })), hasInvisibleOptions && !showAllOptions && !hasChildItems && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.button, "mco-filter-item__button")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    size: "small",
    variant: "text",
    onClick: () => setShowAllOptions(true)
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "filterItem.buttons.more",
    l: l
  })))));
};
var _default = exports.default = Select;